import { render, staticRenderFns } from "./FactSheet.vue?vue&type=template&id=2b9ffb62&scoped=true&"
import script from "./FactSheet.vue?vue&type=script&setup=true&lang=js&"
export * from "./FactSheet.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FactSheet.vue?vue&type=style&index=0&id=2b9ffb62&prod&scoped=true&lang=css&"
import style1 from "./FactSheet.vue?vue&type=style&index=1&id=2b9ffb62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ffb62",
  null
  
)

export default component.exports